import { stringArray } from './stringArray';
import type { ColDefFactory, Column } from './types';

/** Point this column at an array of fixing indices, and they will be rendered as a ", "-concatenated string of display names */
export const fixingIndices: ColDefFactory<Column> = column => ({
  ...stringArray({
    ...column,
    params: {
      getDisplayName: (fixingIndexName, context) =>
        context.current.fixingIndicesByName?.get(fixingIndexName)?.DisplayName ?? fixingIndexName,
      sortByDisplayName: false, // keep the indices in the order they come in from the backend record
    },
  }),
});
